import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import LinkCard from "../../components/LinkCard";
import Alert from "../../components/Alert";
import { Plus, Camera, X } from "lucide-react";
import backendUrl from "../../apiConfig";

function LinkPage({ handleProfileChange, isDarkMode }) {
  const [url, setUrl] = useState("");
  const [title, setTitle] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [links, setLinks] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [linkLoading, setLinkLoading] = useState(false);
  const [showAddLink, setShowAddLink] = useState(false);
  const [name, setName] = useState("");
  const [bio, setBio] = useState("");
  const [username, setUsername] = useState("");

  const [profilePic, setProfilePic] = useState("/placeholder.svg?height=100&width=100");

  const getLinks = useCallback(async () => {
    try {
      setLinkLoading(true);
      const token = localStorage.getItem("jwtToken");
      const response = await axios.get(`${backendUrl}/retrieve/list`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setLinks(response.data.links);
    } catch (error) {
      console.error("Error fetching links:", error);
    } finally {
      setLinkLoading(false);
    }
  }, []);

  useEffect(() => {
    getLinks();
  }, [getLinks]);

  const addLink = useCallback(async () => {
    if (!url.trim() || !title.trim()) {
      setError("Please enter both URL and Title.");
      setShowAlert(true);
      return;
    }

    setLoading(true);
    setShowAlert(false);

    const token = localStorage.getItem("jwtToken");

    try {
      await axios.post(
        `${backendUrl}/links/add`,
        {
          title,
          url,
          // backgroundPhoto: "random.png",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setUrl("");
      setTitle("");
      // setShowAddLink(false);
      getLinks();
      handleProfileChange();
    } catch (error) {
      console.error("Error adding link:", error);
      setError("Failed to add link. Try again.");
      setShowAlert(true);
    } finally {
      setLoading(false);
    }
  }, [url, title, getLinks, handleProfileChange]);

  const handleProfilePicChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfilePic(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };









  useEffect(() => {
    const getUserDetails = async () => {
      const token = localStorage.getItem("jwtToken")

      try {
        const details = await axios.get(`${backendUrl}/user/getuser`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log(details.data);
        setName(details.data.fullName);
        setBio(details.data.bio);
        setUsername(details.data.username);
      } catch (err) {
        console.error("Error fetching user details:", err);
      }
    };

    getUserDetails();
  }, []);

  const changeUserDetails = async () => {
    const token = localStorage.getItem("jwtToken")
    try {
      await axios.put(
        `${backendUrl}/user/bio`,
        { newBio: bio },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("doneeeeeeeeee");
      handleProfileChange();
    } catch (err) {
      console.error("Error editing profile:", err);
    }
  };

  
  const changeUserFullname = async () => {
    const token = localStorage.getItem("jwtToken")

    try {
      await axios.put(
        `${backendUrl}/user/fullname`,
        { newFullname: name },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("doneeeeeeeeee");
      handleProfileChange();
    } catch (err) {
      console.error("Error editing profile:", err);
    }
  };





  return (
    <div className="flex-1 overflow-auto min-h-fit p-4 w-full max-w-2xl mx-auto">
      {/* Profile Section */}
      <div className="w-full h-20 rounded-3xl flex items-center justify-start px-4 mb-4 text-base font-medium border bg-blue-100">
        <p> 🔥 your spelltree is live : <a href={`${backendUrl}/retrieve/html/${username}`} className=" hover:underline cursor-pointer">spelltree/{username}</a></p>
      </div>
      <div className="mb-2 w-[90%] mx-auto text-left flex items-center">
        <div className="relative inline-block">
          <div className="w-16 h-16 rounded-full overflow-hidden">
            <img
              src={profilePic}
              alt="Profile"
              className="w-full h-full object-cover bg-black"
            />
          </div>
          <label className="absolute bottom-0 right-0 p-2 bg-white dark:bg-gray-800 rounded-full shadow-lg cursor-pointer">
            <Camera className="w-4 h-4" />
            <input
              type="file"
              className="hidden"
              accept="image/*"
              onChange={handleProfilePicChange}
            />
          </label>
        </div>
        <div className="flex flex-col ml-4 w-3/4  font-sans">
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onBlur={changeUserFullname} // Calls changeUserFullname when input loses focus
            className={`text-xl mt-2 pb-0 font-bold text-left bg-transparent border-none focus:outline-none ${isDarkMode ? "text-white" : "text-gray-900"
              }`}
          />
          <textarea
            value={bio}
            onChange={(e) => setBio(e.target.value)}
            onBlur={changeUserDetails} // Calls changeUserDetails when textarea loses focus
            className={`w-full text-base text-left bg-transparent border-none focus:outline-none resize-none font-light ${isDarkMode ? "text-gray-300" : "text-gray-500"
              }`}
            rows={2}
          />

        </div>
      </div>

      {/* Add Link Button */}
      {!showAddLink && (
        <button
          onClick={() => setShowAddLink(true)}
          className="w-[90%] mx-auto mb-4 flex items-center justify-center gap-2 bg-purple-600 hover:bg-purple-700 text-white py-3 px-6 rounded-full transition-colors"
        >
          <Plus className="w-5 h-5" />
          Add link
        </button>
      )}

      {/* Add Link Form */}
      {showAddLink && (
        <div
          className={`relative p-12 mb-4 rounded-3xl ${isDarkMode ? "bg-gray-800" : "bg-white"
            }`}
        >
          <button
            onClick={() => setShowAddLink(false)}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 hover:bg-gray-100 w-8 h-8 flex items-center justify-center rounded-md"
          >
            <X className="w-5 h-5" />
          </button>
          {showAlert && (
            <Alert
              setShowAlert={setShowAlert}
              errMsg={error || "Please enter valid inputs!"}
            />
          )}
          <div className="space-y-4">
            <input
              type="text"
              placeholder="URL"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              className={`w-full p-2 rounded-xl focus:outline-none focus:ring-2 ${isDarkMode
                ? "bg-gray-900 border-gray-700 focus:ring-purple-500"
                : "bg-gray-100 border-gray-200 focus:ring-purple-500"
                }`}
            />
            <input
              type="text"
              placeholder="Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className={`w-full p-2 rounded-xl focus:outline-none focus:ring-2 ${isDarkMode
                ? "bg-gray-900 border-gray-700 focus:ring-purple-500"
                : "bg-gray-100 border-gray-200 focus:ring-purple-500"
                }`}
            />
            <button
              onClick={addLink}
              disabled={loading}
              className="w-full py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-xl transition-colors disabled:opacity-50"
            >
              {loading ? "Adding..." : "Add"}
            </button>
          </div>
        </div>
      )}

      {/* Links List */}
      <div className="space-y-4 w-full py-2">
        {linkLoading ? (
          <LoadingSkeleton />
        ) : (
          links.map((link) => (
            <LinkCard
              isDarkMode={isDarkMode}
              title={link.title}
              url={link.url}
              key={link._id}
              id={link._id}
              handleProfileChange={handleProfileChange}
              getLinks={getLinks}
            />
          ))
        )}
      </div>
    </div>
  );
}

const LoadingSkeleton = () => (
  <div className="space-y-4">
    {[1, 2, 3].map((_, index) => (
      <div
        key={index}
        className="w-[90%] mx-auto h-20 rounded-xl my-2 bg-gray-200 dark:bg-gray-400 animate-pulse "
      />
    ))}
  </div>
);

export default LinkPage;
